export default function ServiceSpeed(props) {
	return (
		<div className="text-center">
			<div style={{ color: "#009845", letterSpacing: "0.7px", marginBottom: 2, fontWeight: "bold" }}>Speed</div>
			<div style={{ fontSize: 32, color: "#FF7800", fontWeight: "bold" }}>
				{props.speed}
			</div>
		</div>
	);
}
